module.exports = __webpack_public_path__ + "static/media/ALM.decfe3ae.png";